"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContainer = void 0;
var ROOT_ID = 'root';
var MENU_ITEM_TOOLTIP_CONTAINER_ID = 'menu-item-tooltip-container';
var getContainer = function () {
    var rootElement = document.getElementById(ROOT_ID);
    if (!rootElement) {
        throw new Error('Root element not found');
    }
    var element = document.getElementById(MENU_ITEM_TOOLTIP_CONTAINER_ID);
    if (element) {
        return element;
    }
    var newElement = document.createElement('div');
    newElement.id = MENU_ITEM_TOOLTIP_CONTAINER_ID;
    rootElement.after(newElement);
    return newElement;
};
exports.getContainer = getContainer;
